import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useState, useEffect } from "react";
import { Diagram } from "@/utils/diagramService";

interface EditDiagramDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  diagram: Diagram | null;
  onSave: (name: string) => void;
}

export function EditDiagramDialog({ 
  open, 
  onOpenChange, 
  diagram, 
  onSave 
}: EditDiagramDialogProps) {
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [nameError, setNameError] = useState("");
  const [internalOpen, setInternalOpen] = useState(false);
  
  useEffect(() => {
    if (diagram && open) {
      setName(diagram.name);
      setNameError("");
    }
    setInternalOpen(open);
  }, [diagram, open]);
  
  const validateForm = () => {
    if (!name.trim()) {
      setNameError("O nome é obrigatório");
      return false;
    }
    setNameError("");
    return true;
  };
  
  const handleSave = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        await onSave(name);
        handleOpenChange(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleOpenChange = (newOpen: boolean) => {
    if (isLoading) return;
    
    setInternalOpen(newOpen);
    if (!newOpen) {
      setTimeout(() => {
        onOpenChange(false);
      }, 100);
    } else {
      onOpenChange(true);
    }
  };
  
  return (
    <Dialog open={internalOpen} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editar Diagrama</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <label htmlFor="name" className="text-sm font-medium">
              Nome
            </label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              disabled={isLoading}
              className="col-span-3"
            />
            {nameError && <p className="text-sm text-destructive">{nameError}</p>}
          </div>
        </div>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => handleOpenChange(false)} 
            type="button"
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleSave}
            disabled={isLoading} 
            type="button"
            className="bg-[#9b87f5] hover:bg-[#9b87f5]/90"
          >
            {isLoading ? "Salvando..." : "Salvar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
